import React from 'react';
import { Center } from '@/components/gluestack/center';
import { Text } from '@/components/gluestack/text';
import { RelativeTime } from '@/components/ui/RelativeTime';
import { ConversationItem } from '@/models/Conversation';
import dayjs from '@/i18n/dayjs-config';

interface ConversationTimestampProps {
  currentItem: ConversationItem;
  isVisible: boolean;
}

export function ConversationTimestamp({ currentItem, isVisible }: ConversationTimestampProps) {
  const date = dayjs(currentItem.DateCreated);
  const now = dayjs();

  const isOlderThan24Hours = now.diff(date, 'hour') >= 24;
  const isOlderThanOneWeek = now.diff(date, 'week') >= 1;
  const isOlderThanOneYear = now.diff(date, 'year') >= 1;

  const getFormattedDate = () => {
    if (isOlderThanOneYear) {
      return date.format('ll'); // Ex: Sep 4, 1986
    }
    if (isOlderThan24Hours && !isOlderThanOneWeek) {
      return date.format('dddd'); // Ex: Thursday
    }
    return null; // For relative time
  };

  const formattedDate = getFormattedDate();

  // Always render container to avoid FlashList layout issues, but with no space when not visible
  return (
    <Center
      key={currentItem.Id} // To avoid error Unable to find viewState for tag XXXX on Android
      className={isVisible ? 'my-2' : ''}
      style={{
        opacity: isVisible ? 1 : 0,
        height: isVisible ? undefined : 0,
      }}>
      {isVisible && (
        <>
          {formattedDate ? (
            <Text size="xs" className="text-typography-500">{formattedDate}</Text>
          ) : (
            <RelativeTime date={currentItem.DateCreated} className="text-xs text-typography-500" />
          )}
        </>
      )}
    </Center>
  );
}
